(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Check for URL parameter to show success popup
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('customer_posted')) {
      const successPopup = document.getElementById('successPopup');
      successPopup.classList.add('active');

      // Close success popup handlers
      document.getElementById('closeSuccessPopup').addEventListener('click', function () {
        successPopup.classList.remove('active');
      });

      document.getElementById('closeSuccessBtn').addEventListener('click', function () {
        successPopup.classList.remove('active');
      });

      successPopup.addEventListener('click', function (e) {
        if (e.target === successPopup) {
          successPopup.classList.remove('active');
        }
      });
    }

    // Check if user has already submitted the form
    if (localStorage.getItem('discountFormSubmitted')) {
      document.getElementById('open-dicount-popup').style.display = 'none';
      return;
    }

    const popup = document.getElementById('discountPopup');
    if (!popup) return; // Ensure popup exists
    const closeBtn = popup.querySelector('#closePopup');
    const cardsContainer = popup.querySelector('.custom-cards-container');
    const cards = popup.querySelectorAll('.custom-card');
    const newsletterForm = popup.querySelector('#newsletterForm');
    const generatedFrom = popup.querySelector('#contact_form');
    const discountForm = popup.querySelector('#discountForm');
    const discountTypeInput = popup.querySelector('#discountType');
    const emailContainer = popup.querySelector('.custom-newsletter-form');
    const discountTagInput = popup.querySelector('#discountTag');
    const emailInput = popup.querySelector('#discountEmail');
    const formError = popup.querySelector('#formError');
    const openPopupButton = document.getElementById('open-dicount-popup');

    // Hide the button initially
    openPopupButton.style.display = 'none';

    // Initialize prizes
    const prizes = [
      {
        type: '5_percent',
        url: 'https://res.cloudinary.com/dhznnwqtx/image/upload/v1748867481/5_xuje2r.png',
        tag: 'discount-5-percent',
      },
      {
        type: '100_le',
        url: 'https://res.cloudinary.com/dhznnwqtx/image/upload/v1748867481/100LE_1_mj3ydq.png',
        tag: 'discount-100-le',
      },
      {
        type: '100_le',
        url: 'https://res.cloudinary.com/dhznnwqtx/image/upload/v1748867481/100LE_1_mj3ydq.png',
        tag: 'discount-100-le',
      },
      //   {
      //     type: '200_le',
      //     url: 'https://res.cloudinary.com/dhznnwqtx/image/upload/v1748867481/200LE_1_rghhex.png',
      //     tag: 'discount-200-le',
      //   },
    ];

    // Shuffle prizes
    const shuffledPrizes = [...prizes].sort(() => 0.5 - Math.random());

    // Check if popup was recently closed
    const lastClosedTime = localStorage.getItem('popupLastClosedTime');
    const now = new Date().getTime();
    const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds

    function showPopupWithDelay() {
      // If popup was closed less than 1 hour ago, don't show it
      if (lastClosedTime && now - lastClosedTime < oneHour) {
        return;
      }

      // Show popup after 5 seconds
      setTimeout(() => {
        popup.classList.add('active');
        openPopupButton.classList.add('hide');
      }, 5000);
    }

    // Only auto-show if not submitted and not recently closed
    if (!localStorage.getItem('discountFormSubmitted')) {
      showPopupWithDelay();
    }

    // card click handler
    cards.forEach((card) => {
      card.addEventListener('click', function () {
        if (this.classList.contains('flipped')) return;

        const index = parseInt(this.getAttribute('data-index'));
        const prize = shuffledPrizes[index];

        // Flip the selected card
        this.classList.add('flipped');

        // Set the back face content
        const backFace = this.querySelector('.custom-card-back');
        backFace.innerHTML = `<img class="prize-img" src="${prize.url}">`;

        // Disable all cards
        cardsContainer.classList.add('custom-disabled');

        emailContainer.classList.add('active');

        discountTagInput.value = `newsletter,${prize.tag}`;
      });
    });

    // Close popup
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('active');
      openPopupButton.classList.remove('hide');
      // Store the time when popup was closed
      localStorage.setItem('popupLastClosedTime', new Date().getTime());
    });

    // If the user clicks outside the popup, close it
    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        popup.classList.remove('active');
        openPopupButton.classList.remove('hide');
        // Store the time when popup was closed
        localStorage.setItem('popupLastClosedTime', new Date().getTime());
      }
    });

    // Form submission handler
    generatedFrom.addEventListener('submit', function (event) {
      if (!cardsContainer.classList.contains('custom-disabled')) {
        event.preventDefault();
        formError.textContent = 'Please pick a card to claim your prize.';
        return;
      }

      if (!emailInput.value || !emailInput.checkValidity()) {
        event.preventDefault();
        formError.textContent = 'Please enter a valid email address.';
        return;
      }

      // Store submission in local storage
      localStorage.setItem('discountFormSubmitted', 'true');

      formError.textContent = ''; // Clear any previous error messages
    });

    // Show popup on button click (manual trigger)
    openPopupButton.addEventListener('click', function () {
      popup.classList.add('active');
      openPopupButton.classList.add('hide');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
